export interface WidgetRuntime {
  origin: string;
}

type WidgetWindow = Window & { zenvoyaMcp?: WidgetRuntime };

export const widgetRuntime = (): WidgetRuntime | undefined =>
  typeof window === "undefined" ? undefined : (window as WidgetWindow).zenvoyaMcp;

export const isWidgetRuntime = (): boolean => !!widgetRuntime();

export const assetOrigin = (): string => widgetRuntime()?.origin ?? "";
